import api from "../api";

export const patchValidationPin = async (body) => {
  return api
    .patch({
      body,
      endpoint: "/secure-code/validation",
      port: process.env.REACT_APP_PORT_VENUE,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
